$(function () {

    // モーダル閉じるボタン
    $(".modal_close").on("click", function () {
        startScroll();
        $('.overlay_modal').fadeOut();
    });
    // モーダル以外クリックでモーダル閉じる
    $(".mymodal").on("mousedown touchstart", function (e) {
        e.stopPropagation();
    });
    $(".overlay_modal").on("mousedown touchstart", function (e) {
        startScroll();
        $('.overlay_modal').fadeOut();
        e.stopPropagation();
    });
});


// スクロールバー（ずれる）対策用
$(function () {
    window.load_clientWidth = document.body.clientWidth;
    $(window).on('resize', function () {
        load_clientWidth = document.body.clientWidth;
    });
});

window.posi = 0;

// オーバーレイ（プログレスバー）表示時のスクロール禁止
export function stopScroll() {
    posi = $(window).scrollTop();
    $('body').css({
        //'position': 'fixed',
        //'top': -1 * posi,
        'width': '100%',
        'height': '100vh',
        'overflow': 'hidden',
    });

    // スクロールバー（ずれる）対策用
    let now_clientWidth = document.body.clientWidth;

    if ((now_clientWidth - load_clientWidth) > 0) {
        $('body').css({
            'padding-right': (now_clientWidth - load_clientWidth) + 'px'
        });
    }
}
export function startScroll() {
    $('body').css({
        //'position': 'relative',
        //'top': 0,
        'width': 'auto',
        'height': 'auto',
        'padding-right': '0px',
        'overflow': 'auto',
    });
    $('html, body').prop({ scrollTop: posi });
}

